$(document).ready(function () {
  $('.manufacture-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    mobileFirst: true,
    arrows: false,
    dots: true,
    responsive: [
      {
        breakpoint: 575,
        settings: 'unslick'
      }
    ]
  });


  var $dialogTrigger = $('.poptrigger'),
    $productPriceSection = $('.product-price-section'),
    $productDetailsSection = $('.product-details'),
    $pagebody = $('body');
    
  $dialogTrigger.click(function () {
    var popID = $(this).attr('data-rel');
    $('body').addClass('overflowhidden');
    var winHeight = $(window).height();
    $('#' + popID).fadeIn();
    var popheight = $('#' + popID).find('.popup-block').outerHeight(true);

    if ($('.popup-block').length) {
      var popMargTop = popheight / 2;
      //var popMargLeft = ($('#' + popID).find('.popup-block').width()/2);

      if (winHeight > popheight) {
        $('#' + popID).find('.popup-block').css({
          'margin-top': -popMargTop,
          //'margin-left' : -popMargLeft
        });
      } else {
        $('#' + popID).find('.popup-block').css({
          'top': 0,
          //'margin-left' : -popMargLeft
        });
      }

    }

    $('#' + popID).append("<div class='modal-backdrop'></div>");
    $('.popouterbox .modal-backdrop').fadeTo("slow", 0.70);
    if (popheight > winHeight) {
      $('.popouterbox .modal-backdrop').height(popheight);
    }
    $('#' + popID).focus();
    return false;
  });

  $(window).on("resize", function () {
    if ($('.popouterbox').length && $('.popouterbox').is(':visible')) {
      var popheighton = $('.popouterbox .popup-block').height() + 60;
      var winHeight = $(window).height();
      if (popheighton > winHeight) {
        $('.popouterbox .modal-backdrop').height(popheighton);
        $('.popouterbox .popup-block').removeAttr('style').addClass('taller');

      } else {
        $('.popouterbox .modal-backdrop').height('100%');
        $('.popouterbox .popup-block').removeClass('taller');
        $('.popouterbox .popup-block').css({
          'margin-top': -(popheighton / 2)
        });
      }
    }
  });

  //Close popup		
  $(document).on('click', '.close-dialogbox, .modal-backdrop', function () {
    $(this).parents('.popouterbox').fadeOut(300, function () {
      $(this).find('.modal-backdrop').fadeOut(250, function () {
        $('body').removeClass('overflowhidden');
        $('.popouterbox .popup-block').removeAttr('style');
        $(this).remove();
      });
    });
    return false;
  });



  $('.product-info .add-card-row .product_option_select').change(function () {
    var currentval = $(this).val();
    $('.input_variant').val(currentval);
    console.log(100);
    setTimeout(function () {
      if ($('.switch-box').find('.checkbox').is(':checked')) {
        console.log(10000);
        var normalprice = +jQuery('.rc_price__onetime span.money').html();
        var discountedprice = +jQuery('.rc_price__autodeliver span.money').html();

        if (normalprice == discountedprice) {
          $('.old-price').hide()
        } else {
          $('.old-price').html(normalprice).show();
        }
        $('.subscribe-price .old-price').html(normalprice);
        $('.subscribe-price .new-price').html(discountedprice);
      } else {
        console.log(20000);
        $('.product-price-section .old-price').hide();
      }
    }, 100);
  });
  $('.switch-box').click(function () {
    if ($('.switch-box').find('.checkbox').is(':checked')) {
      var normalprice = +jQuery('.rc_price__onetime span.money').html();
      var discountedprice = +jQuery('.rc_price__autodeliver span.money').html();

      if (normalprice == discountedprice) {
        // $('.old-price').hide()
      } else {
        // $('.old-price').html(normalprice).show();
        $('.old-price').html(normalprice);
      }
      $('.subscribe-price .old-price').html(normalprice);
      $('.subscribe-price .new-price').html(discountedprice);
      $(".rc_radio__autodeliver").prop('checked', true).trigger('click');
      // $productPriceSection.removeClass('product-price-section-subscription');
      $productDetailsSection.removeClass('product-details-subscription');
    } else {
      $(".rc_radio__onetime").prop('checked', true).trigger('click');
      // $('.product-price-section .old-price').hide();
      // $productPriceSection.addClass('product-price-section-subscription');
      $productDetailsSection.addClass('product-details-subscription');
    }
  });
  $('.product-info .select_frequency select').change(function () {
    var currentval = $(this).val();
    console.log(currentval);
    $('.rc_select.rc_select__frequency').val(currentval);
  });
  setTimeout(function () {
    var currentval = $('.product-info .select_frequency select').val()
    if (currentval) {
      $('.rc_select.rc_select__frequency').val(currentval);
    }
    var normalprice = +jQuery('.rc_price__onetime span.money').html();
    var discountedprice = +jQuery('.rc_price__autodeliver span.money').html();
    $('.product-price-section .old-price').html(normalprice);
    if (normalprice == discountedprice) {
      $('.old-price').hide()
    } else {
      $('.old-price').html(normalprice).show();
    }
    $('.subscribe-price .old-price').html(normalprice);
    $('.subscribe-price .new-price').html(discountedprice);
  }, 3000);


});